module.exports = __webpack_public_path__ + "img/ico-save-brand-color.7cc5da79.svg";